
$(function(){
  $('body').on('click','.col-add-to-cart',function(){
    $(this).addClass(' btn--loading');
    var id = $(this).attr('data-vid');
    var $this=$(this);
    var q = 1;
    var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + id,
        dataType: "json",
        success: function (n) {
          $this.removeClass('btn--loading');
          var cart = new theme.CartDrawer
          cart.init()
          cart.open();
           
        },
        error: function (n, c) {
          $this.removeClass('btn--loading');
           console.log('fail');
        }
     };
    jQuery.ajax(ajax);
  });

  $('.home-productlist .grid.grid--uniform').slick({
  dots: false,
  infinite: true,
  arrows:true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});



equalheight = function(container){

  var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
  $(container).each(function() {
    $el = $(this);
    $($el).height('auto')
    var topPostion = $el.position().top;

    if (currentRowStart != topPostion) {
      for (var currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}
$(document).ready(function(){
    equalheight('.grid__item .grid-product__title');
   setTimeout(() => { 
        equalheight('.grid__item .grid-product__title');
    }, 2000);
  $(window).on('resize', function(){
  equalheight('.grid__item .grid-product__title');
});
});